var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 95,
	"./layouts/card/style.module.scss": 95,
	"./layouts/components/breadcrumbs": 122,
	"./layouts/components/breadcrumbs/": 122,
	"./layouts/components/breadcrumbs/index": 122,
	"./layouts/components/breadcrumbs/index.tsx": 122,
	"./layouts/components/breadcrumbs/style.module": 173,
	"./layouts/components/breadcrumbs/style.module.scss": 173,
	"./layouts/components/container": 42,
	"./layouts/components/container/": 42,
	"./layouts/components/container/index": 42,
	"./layouts/components/container/index.tsx": 42,
	"./layouts/components/container/style.module": 124,
	"./layouts/components/container/style.module.scss": 124,
	"./layouts/components/footer": 123,
	"./layouts/components/footer/": 123,
	"./layouts/components/footer/index": 123,
	"./layouts/components/footer/index.tsx": 123,
	"./layouts/components/footer/style.module": 86,
	"./layouts/components/footer/style.module.scss": 86,
	"./layouts/components/loading_indicator": 64,
	"./layouts/components/loading_indicator/": 64,
	"./layouts/components/loading_indicator/index": 64,
	"./layouts/components/loading_indicator/index.tsx": 64,
	"./layouts/components/nav_bar": 94,
	"./layouts/components/nav_bar/": 94,
	"./layouts/components/nav_bar/index": 94,
	"./layouts/components/nav_bar/index.tsx": 94,
	"./layouts/components/nav_bar/standalone": 325,
	"./layouts/components/nav_bar/standalone.tsx": 325,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 85,
	"./layouts/components/notice_banner/": 85,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 174,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 174,
	"./layouts/components/notice_banner/index": 85,
	"./layouts/components/notice_banner/index.tsx": 85,
	"./layouts/components/notice_banner/standalone": 326,
	"./layouts/components/notice_banner/standalone.tsx": 326,
	"./layouts/components/notice_banner/style.module": 175,
	"./layouts/components/notice_banner/style.module.scss": 175,
	"./layouts/page": 92,
	"./layouts/page/": 92,
	"./layouts/page/index": 92,
	"./layouts/page/index.tsx": 92,
	"./layouts/page/style.module": 87,
	"./layouts/page/style.module.scss": 87,
	"./layouts/types": 327,
	"./layouts/types.ts": 327,
	"./marketing/pages/home/toefl": 1603,
	"./marketing/pages/home/toefl/": 1603,
	"./marketing/pages/home/toefl/index": 1603,
	"./marketing/pages/home/toefl/index.tsx": 1603,
	"./marketing/pages/home/toefl/sections/ai": 1212,
	"./marketing/pages/home/toefl/sections/ai/": 1212,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1897,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1897,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1898,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1898,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1899,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1899,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1900,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1900,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge": 1901,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge.svg": 1901,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1902,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1902,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1903,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1903,
	"./marketing/pages/home/toefl/sections/ai/index": 1212,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1212,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1904,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1904,
	"./marketing/pages/home/toefl/sections/apps": 1213,
	"./marketing/pages/home/toefl/sections/apps/": 1213,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1905,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1905,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1906,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1906,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1907,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1907,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1908,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1908,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1909,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1909,
	"./marketing/pages/home/toefl/sections/apps/index": 1213,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1213,
	"./marketing/pages/home/toefl/sections/features": 1214,
	"./marketing/pages/home/toefl/sections/features/": 1214,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1910,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1910,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1911,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1911,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1912,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1912,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1913,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1913,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1914,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1914,
	"./marketing/pages/home/toefl/sections/features/index": 1214,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1214,
	"./marketing/pages/home/toefl/sections/official_questions": 1218,
	"./marketing/pages/home/toefl/sections/official_questions/": 1218,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1923,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1923,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1218,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1218,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 757,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 757,
	"./marketing/pages/home/toefl/sections/value_props": 1215,
	"./marketing/pages/home/toefl/sections/value_props/": 1215,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1915,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1915,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1916,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1916,
	"./marketing/pages/home/toefl/sections/value_props/index": 1215,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1215,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2300,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2300,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1216,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1216,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1917,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1917,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1918,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1918,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1919,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1919,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1920,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1920,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1921,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1921,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1216,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1216,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 756,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 756,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1217,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1217,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1922,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1922,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1217,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1217,
	"./marketing/pages/home/toefl/style.module": 1924,
	"./marketing/pages/home/toefl/style.module.scss": 1924,
	"./marketing/pages/plans/toefl": 1604,
	"./marketing/pages/plans/toefl/": 1604,
	"./marketing/pages/plans/toefl/index": 1604,
	"./marketing/pages/plans/toefl/index.tsx": 1604,
	"./marketing/pages/plans/toefl/sections/testimonials": 1219,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1219,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1925,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1925,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1926,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1926,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1219,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2642;